<template>
  <div class="blog">
    <h4 class="module__title">{{ meta.title }}</h4>
    <div class="module__description">{{ meta.description }}</div>
    <div class="blog__wrap" v-loading="isLoading">
      <a v-for="article in blog" :key="article.title" :href="article.link" class="blog__card" target="_blank">
        <div class="blog__card__content flex">
          <figure class="blog__card__content__cover flex-no-shrink">
            <img class="blog__card__content__cover__img" v-lazy="article.img ? article.img + `?height=${blogImageHeight*MAGNIFACATION}&format=webp` : require('@/assets/images/default-room.jpg')" alt="blog image" />
          </figure>
          <div class="blog__card__content__text flex h-full">
            <div class="mb-auto">
              <h5 class="mb-8" v-html="article.title"></h5>
              <div class="text-sm text-grey-dark leading-normal hidden md:block" v-html="article.description">
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import request from 'axios'

export default {
  name: 'module_Blog',
  props: ['meta', 'data'],
  data () {
    return {
      isLoading: false,
      blog: [],
      cover: [],
      MAGNIFACATION: 1.5
    }
  },
  computed: {
    ...mapGetters([
      'initWidth'
    ]),
    blogImageWidth: function () {
      if (this.initWidth >= 1200) {
        return 181
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 311
      } else if (this.initWidth < 992 && this.initWidth >= 768) {
        return 236
      } else if (this.initWidth < 768 && this.initWidth >= 576) {
        return 275
      } else {
        return 146
      }
    },
    blogImageHeight: function () {
      if (this.initWidth >= 1200) {
        return 120
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 200
      } else if (this.initWidth < 992 && this.initWidth >= 768) {
        return 120
      } else if (this.initWidth < 768 && this.initWidth >= 576) {
        return 120
      } else {
        return 100
      }
    }
  },
  methods: {
    ...mapActions([
      'events/fetchEvent'
    ]),
    getBlogList () {
      if (this.$route.name === 'Event') {
        this.getEventBlogList()
      } else {
        this.getDefaultBlogList()
      }
    },
    getDefaultBlogList () {
      this.isLoading = true
      request({
        url: `${process.env.VUE_APP_API}/v3/articles`
      }).then(res => {
        this.blog = res.data.data
      }).finally(() => (this.isLoading = false))
    },
    getEventBlogList () {
      this.isLoading = true
      this['events/fetchEvent'](this.$route.params.eventId)
        .then(res => {
          this.blog = res.articles
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  mounted () {
    this.getBlogList()
  },
  watch: {
    '$route': function (to, from) {
      this.getBlogList()
    }
  }
}
</script>

<style lang="sass">
.blog
  @apply mb-0 py-16
  @screen md
    @apply mb-48 -mx-8 py-0
  &__wrap
    @apply flex flex-wrap mb-0
    @screen sm
      @apply mb-16
  &__card
    @apply no-underline
    @apply mb-24 w-full
    @screen sm
      @apply w-1/2
    @screen md
      @apply w-1/3
    @screen xl
      @apply w-1/2
      &:nth-child(odd)
        padding-left: 8px
      &:nth-child(even)
        padding-right: 8px
    &:hover
      .blog__card__content__cover__img
        transform: scale(1.1)
    &__content
      @apply mx-16 flex h-full ease overflow-hidden
      @apply flex-row
      @screen sm
        @apply flex-col mx-8
      @screen xl
        @apply flex-row
      // &:hover
      //   @apply shadow
      &__cover
        @apply overflow-hidden
        max-width: 145px
        height: 100px
        border-radius: 1.25rem
        @screen sm
          @apply w-full
          height: 120px
          max-width: 100%
        @screen lg
          height: 200px
        @screen xl
          width: 180px
          height: 120px
          @apply mr-16
        &__img
          @apply h-full w-full
          transition: all 0.5s ease
          object-fit: cover
          // padding-left: imageRatio(900, 465)
          background:
            position: center
            repeat: no-repeat
            size: contain
            color: #f7f7f7
          transform: scale(1.005)
      &__text
        @apply flex flex-col justify-around ml-16
        @screen sm
          @apply ml-0
        @screen xl
          @apply
        h5
          @apply font-bold text-grey-darker
        .more-link
          @apply hidden
        &__time
          @apply text-grey text-xs text-right
</style>
